import { Col, Row } from "react-bootstrap"
import { IoIosCloseCircle } from "react-icons/io"
import { useParams } from "react-router"
import { Link } from "react-router-dom"
import FormRole from "../../components/role/FormRole"

function EditRole(){
    const {id} = useParams()

    return (
        <>
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">Editar rol</h2>
                </Col>
                <Col xs="12" md="4" className="text-right">
                    <Link to="/admin/roles"><IoIosCloseCircle className="cancel-btn"/></Link>                    
                </Col>
            </Row>
            <FormRole id={id} />
        </>
    )

}

export default EditRole